export default __webpack_public_path__ + "static/media/sana.450e6275.png";